import React from "react";

type Props = {
  number: string;
};

const FormatMobileNumber: React.FC<Props> = ({ number }) => {
  const formatUSMobile = (num: string): string => {
    const digits = num.replace(/\D/g, "");
    if (digits.length === 10) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    return num;
  };

  return <span>{formatUSMobile(number)}</span>;
};

export default FormatMobileNumber;
